const u = (id, w = 900) =>
    `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

const px = (id, w = 900) =>
    `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const BEFORE_AFTER = [
    { id: "ba1", title: "Kuchnia — metamorfoza", before: px(5691495), after: u("photo-1484154218962-a197022b5858") },
    { id: "ba2", title: "Salon — metamorfoza", before: px(19503382), after: u("photo-1502672260266-1c1ef2d93688") },
    { id: "ba3", title: "Łazienka — metamorfoza", before: px(36035073), after: u("photo-1629079447777-1e605162dc8d") },
];

export const IMAGES = {
    hero: px(8146336, 1400),
    aboutMain: px(9551388, 900),
    aboutSmall: u("photo-1567767292278-a4f21aa2d36e", 700),
    ctaBg: u("photo-1606676539940-12768ce0e762", 1600),
};

export const GALLERY_CATEGORIES = [
    "Wszystkie",
    "Łazienki",
    "Kuchnie",
    "Elektryka",
    "Hydraulika",
    "Malowanie",
    "Płytki",
];

export const GALLERY = [
    { id: "g1", cat: "Kuchnie", src: u("photo-1484154218962-a197022b5858"), title: "Kuchnia po remoncie — biała zabudowa", aspect: "aspect-[4/5]" },
    { id: "g2", cat: "Łazienki", src: px(33054906), title: "Łazienka po remoncie — Kraków", aspect: "aspect-[3/4]" },
    { id: "g3", cat: "Malowanie", src: u("photo-1502672260266-1c1ef2d93688"), title: "Salon po malowaniu", aspect: "aspect-square" },
    { id: "g4", cat: "Elektryka", src: u("photo-1544724569-5f546fd6f2b5"), title: "Rozdzielnia i nowa instalacja", aspect: "aspect-[4/5]" },
    { id: "g5", cat: "Hydraulika", src: px(6899357), title: "Biały montaż i wymiana instalacji", aspect: "aspect-[3/4]" },
    { id: "g6", cat: "Płytki", src: u("photo-1629079447777-1e605162dc8d"), title: "Prysznic — glazura pod sufit", aspect: "aspect-square" },
    { id: "g7", cat: "Kuchnie", src: u("photo-1522708323590-d24dbb6b0267"), title: "Aneks kuchenny po wykończeniu", aspect: "aspect-[3/4]" },
    { id: "g8", cat: "Łazienki", src: u("photo-1552321554-5fefe8c9ef14"), title: "Biały montaż i armatura", aspect: "aspect-[4/5]" },
    { id: "g9", cat: "Malowanie", src: u("photo-1493809842364-78817add7ffb"), title: "Pokój dzienny po remoncie", aspect: "aspect-square" },
    { id: "g10", cat: "Elektryka", src: u("photo-1598928636135-d146006ff4be"), title: "Montaż oświetlenia w sypialni", aspect: "aspect-[3/4]" },
    { id: "g11", cat: "Płytki", src: px(33054914), title: "Płytki w łazience — Kraków", aspect: "aspect-[4/5]" },
    { id: "g12", cat: "Malowanie", src: u("photo-1560185893-a55cbc8c57e8"), title: "Sypialnia po malowaniu", aspect: "aspect-square" },
];
